/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:55:49
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ကို ဖြင့္ပါ",
    name2: "ႀကိဳတင္မွာယူမႈ ျပဳလုပ္ပါ",
    name3: "Carlcare ျဖင့္၊ သင္သည္ သင့္အမွာစာကို အခ်ိန္မေရြး စစ္ၾကည့္ႏိုင္ပါသည္။",
    name4: "",
    name5: "ညာဘက္သို႔ ပြတ္ေပးပါ",
    name6: "အတည္ျပဳခ်က္ ၿပီးပါၿပီ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "စက္ေမာ္ဒယ္ကို ေ႐ြးပါ",
    name2: "ပ်က္စီးမႈေဖာ္ျပခ်က္ -",
    name3: "ဝန္ေဆာင္မႈ စတိုးဆိုင္ကို ေ႐ြးခ်ယ္ရန္ ႏွိပ္ပါ",
    name4: "ဝန္ေဆာင္မႈစတိုးဆိုင္-",
    name5: "ႀကိဳတင္မွာယူမႈ အခ်ိန္-",
    name6: "သင့္စက္ ျပႆနာကို အေသးစိတ္ ေဖာ္ျပေပးပါ။",
    name7: "ဆိုက္ေရာက္ခ်ိန္ကို ေ႐ြးခ်ယ္ရန္ ႏွိပ္ပါ",
    name8: "သင့္ထံဆက္သြယ္ႏိုင္ရန္ သင္၏ မွန္ကန္ေသာ ဆက္သြယ္ရန္အေသးစိတ္အခ်က္မ်ားကို ထည့္သြင္းေပးပါ",
    name9: "ရရွိႏိုင္ေသာ ႀကိဳတင္မွာယူခ်ိန္မွာ ေဖာ္ျပပါအတိုင္းျဖစ္ပါသည္",
    name10: "ေက်းဇူးျပဳ၍ သင့္ဖုန္းနံပါတ္ကို ထည့္သြင္းပါ",
    name11: "ေဈးႏႈန္း",
    name12: "ကိုယ္ေရးကိုယ္တာ သတင္းအခ်က္အလက္ -",
    name13: "သင္၏အမည္ကို ထည့္သြင္းေပးပါ",
    name14: "တင္ျပရန္",
    name15: "မလုပ္ပါ",
    name16: "အိုေက",
  },
  shops: {
    name1: "သင္ေ႐ြးခ်ယ္သည့္ အမွတ္တံဆိပ္အေပၚ မူတည္၍ ေအာက္ပါ စတိုးဆိုင္မ်ားက သင့္ကို ျဖည့္ဆည္းေပးႏိုင္ပါသည္။",
    name2: "ေနာက္ထပ္ လက္လီစတိုးမ်ားတြင္ မၾကာမီရပါမည္။ ကၽြႏု္ပ္တို႔ႏွင့္ ရွိေနပါ။",
  },
  price: {
    name1: "ကုန္အမွတ္တံဆိပ္",
    name2: "ေမာ္ဒယ္",
    name3: "အရာဝတၳဳ",
    name4: "ေဈးႏႈန္း",
    name5: "ခင္မင္စြာ အသိေပးခ်က္-",
    name6: "ထိုေဈးႏႈန္းမ်ားသည္ ကိုးကားရန္သက္သက္ျဖစ္ၿပီးဝ တကယ့္ေဈးႏႈန္းသည္ သင့္စက္အေျခအေနႏွင့္ သက္ဆိုင္ပါသည္။",
    name7: "အကယ္၍ အထူးသေကၤတမရွိလွ်င္ တန္ဖိုးယူနစ္သည္ နိဳင္ငံတြင္း ေငြေၾကးယူနစ္ ျဖစ္သည္။",
    name8: "ဝမ္းနည္းပါသည္။ လက္ရွိေဒသတြင္ ေဈးႏႈန္းအခ်က္အလက္မ်ား မရရွိႏိုင္ပါ။",
    name11:"အလုပ္သမားကုန္က်စရိတ္",
    name12:"စုစုေပါင္းေစ်းႏႈန္း",
    name13: "5. လုပ္အားခသည္ \"/\" ျဖစ္ပါက စတိုးဆိုင္ႏွင့္ ညႇိႏႈိင္းရန္ လိုအပ္သည္ဟု ဆိုလိုသည္။",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen(Frame)",
    item_screen_screen_frame: "Secondary Screen(Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "ကင္မရာ",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Secondary Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Receiver",
    item_small_board: "Small Board",
    item_battery_cover: "Battery Cover",
    item_battery: "Battery",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ေဒတာမရွိ",
    name2: "ဝန္ေဆာင္မႈေပးသူ-",
    name3: "ဝန္ေဆာင္မႈ အမွတ္တံဆိပ္ -",
    name4: "တယ္လီဖုန္း-",
    name5: "မွာယူမႈ အေရအတြက္-",
    name6: "ဝန္ေဆာင္မႈ အဆင့္သတ္မွတ္ခ်က္",
    name7: "ဝန္ေဆာင္မႈ ပတ္ဝန္းက်င္-",
    name8: "ဝန္ေဆာင္မႈ သေဘာထား-",
    name9: "ဝန္ေဆာင္မႈ အက်ဳိးမ်ားမႈ-",
    name10: "ဝန္ေဆာင္မႈ အရည္အေသြး-",
    name11: "ဝယ္ယူသူ အကဲျဖတ္မႈ",
    name12:"မွ",
    name13:"ပိတ္မည္",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ကို ဖြင့္ပါ",
    name1: "ႀကိဳတင္မွာယူမႈအခ်က္အလက္ကို စခရင္ေရွာ့႐ိုက္ထားကာ ဦးစားေပးဝန္ေဆာင္မႈကို အသုံးျပဳႏိုင္ရန္ ေျပစာတစ္ခုအျဖစ္ ၎ကို သိမ္းထားပါ။",
    name2: "ေအာင္ျမင္စြာ တင္သြင္းၿပီးပါၿပီ",
    name3: "1. ေဒတာကို ရွင္းလင္းပါ",
    name4: "သင့္ဖုန္းတြင္ အေရးႀကီးေသာ သီးသန႔္ေဒတာမ်ားကို ႀကိဳတင္၍ အရန္သိမ္းပါ",
    name5: "2. ပါဝါ-ဖြင့္ စကားဝွက္ကို ပိတ္ပါ",
    name6: "ဝန္ေဆာင္မႈစတိုးထံ သြားေရာက္ျခင္းမျပဳမီ၊ ေက်းဇူးျပဳ၍-",
    name7: "ဝန္ေဆာင္မႈစတိုးဆိုင္-",
    name8: "ႀကိဳတင္မွာယူမႈ အခ်ိန္-",
    name9: "ပ်က္စီးမႈေဖာ္ျပခ်က္ -",
    name10: "စက္ေမာ္ဒယ္-",
    name11: "အမွာစာနံပါတ္-",
    name12: "မွာယူမႈ အခ်က္အလက္",
  },
  title: {
    
    name1: "ေဖာ္ျပပါႏိုင္ငံမ်ားကို ပံ့ပိုးေပးပါသည္-",
    name2: "ေမာ္ဒယ္ကို ေ႐ြးခ်ယ္ပါ",
    name3: "ႀကိဳတင္မွာယူမႈ",
    name4: "ဝန္ေဆာင္မႈစတိုးဆိုင္ အေသးစိတ္မ်ား",
    name5: "ဝန္ေဆာင္မႈ စတိုးဆိုင္ကို ေ႐ြးခ်ယ္ရန္",
  },
  error: {
    
    name1: "ေဒတာမရွိပါ။ သင္၏ ျပဳျပင္မႈအခ်က္အလက္ကို စစ္ေဆးပါ",
    name2: "အကူအညီ ပိုမိုလိုအပ္ပါသလား။ ေက်းဇူးျပဳ၍ ကၽြႏ္ုပ္တို႕ႏွင့္ ဆက္သြယ္ပါ။",
    name3: "ဝမ္းနည္းပါသည္၊ လက္ရွိေဒသတြင္ Carlcare စင္တာ မရွိပါ။",
    name4: "ဦးစြာ ဝန္ေဆာင္မႈစင္တာကို ေရြးေပးပါ",
    name5: "မေအာင္ျမင္ပါ",
    name6: "ဦးစြာ စက္ေမာ္ဒယ္ကို ေရြးေပးပါ",
    name7: "အေသးစိတ္",
    name8: "သင့္လိုအပ္ခ်က္မ်ားကို အေသးစိတ္ ေဖာ္ျပေပးပါ",
    name9: "",
  },
  add1:{
    "name0": "my-rZG",
    "name1": "သင့္မွာယူမႈကို အတည္ျပဳၿပီးပါၿပီ။ သင့္ေရာက္လာျခင္းကို ကြၽႏ္ုပ္တို႔ ေမွ်ာ္လင့္ပါသည္။",
    "name2": "ၿမိဳ႕ ေရြးပါ",
    "name3": "ေက်းဇူးျပဳ၍ ဖုန္းနံပါတ္ ဂဏန္း %1$s လုံးကို ထည့္ပါ။",
    "name4": "အလုပ္လုပ္ခ်ိန္နာရီ",
    "name5": "တနလၤာ",
    "name6": "အဂၤါ",
    "name7": "ဗုဒၶဟူး",
    "name8": "ၾကာသပေတး",
    "name9": "ေသာၾကာ",
    "name10": "စေန",
    "name11": "တနဂၤေႏြ",
    "name12": "ႏိုင္ငံကို ႐ိုက္ထည့္ၿပီး ရွာေဖြပါ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "အျခား",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ျပန္ၫႊန္းရန္ ႏွိပ္ပါ",
    name3:"မွာယူမႈကို အဆင့္သတ္မွတ္ရန္ Carlcare အက္ပ္ကိုဖြင့္ပါ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ဝန္ေဆာင္မႈကို ေ႐ြးခ်ယ္ပါ",
    name7:"အခမဲ့ သန႔္ရွင္းေရး",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "အခ်က္အလက္မမွန္ပါ",
    "cancelReason1": "အခ်ိန္မီ မေရာက္ႏိုင္ပါ",
    "cancelReason2": "မိတၱဴပြားေအာ္ဒါ/ကြၽႏ္ုပ္၏ေအာ္ဒါ မဟုတ္ပါ",
    "cancelReason3": "ရႈံးနိမ့္မႈ ထပ္မျဖစ္ပါ",
    "cancelReason4": "စမ္းသပ္မႈ/စုံစမ္းမႈ/ပြဲစဥ္/… အတြက္သာျဖစ္သည္။",
    "cancelReason5": "ေဈးႀကီးသည္",
    "cancelReason6": "ပစၥည္းျပတ္လပ္မႈ",
    "cancelReason7": "ကြဲျပားေသာဝန္ေဆာင္မႈမ်ားမရွိပါ",
    "cancelReason8": "စတိုးဆိုင္ကအရမ္းေဝးတယ္",
    "cancelReason9": "ဆိုင္ပိတ္ထားသည္",
    "cancelReason10": "ဝန္ေဆာင္မႈ သေဘာထား မေကာင္းပါ",
    "cancelReason11": "အျခားအမွတ္တံဆိပ္မ်ားအတြက္ အစားထိုး/ျပဳျပင္ျခင္း",
    "cancelReason12": "ဆိုင္ကို ရွာမေတြ႕ပါ",
    "cancelReason13": "အျခား",
    "cancelOrder": "မွာယူမႈကို ပယ္ဖ်က္ရန္",
    "reason_dialog_title": "ဖ်က္သိမ္းရသည့္အေၾကာင္းရင္းကို ေက်းဇူးျပဳ၍ ေျပာျပပါ",
    "Cancel": "မလုပ္ပါ",
    "OK": "အိုေက",
    "name1": "အတည်ပြုကုဒ်ကို ဖြည့်ပါ",
    "name2": "အတည်ပြုကုဒ် မှားနေသည်",
    "repair_reservation_detail_canceled": "ဤမွာယူမႈကို ပယ္ဖ်က္ထားသည္။",
    "purchase_cancel_dialog_content": "မွာယူမႈကို ပယ္ဖ်က္ရန္ သင္‌ေသခ်ာပါသလား?",
    "yes": "ဟုတ္ပါသည္",
    "no": "မဟုတ္ပါ"
}
};
